<template>
  <div class="offcanvas-body p-0 bg-white">
    <div class="list-group list-group-flush" v-for="(row, index) in mailHistories" :key="index" :role="rowRole(row)">
      <notification-area-data :row="row" :unread-checked="unreadChecked" @update="updateIsRead(index)" />
    </div>
    <infinite-loading @infinite="infiniteHandler" :identifier="reset">
      <template #spinner>
        <div class="d-flex justify-content-center p-1">
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">データ取得中</span>
          </div>
        </div>
      </template>
      <template #complete>
        <div class="d-flex justify-content-center p-1">
          <div v-if="noNotification">
            <span>通知はありません。</span>
          </div>
          <div v-else>
            <span>これ以上通知はありません。</span>
          </div>
        </div>
      </template>
      <template #error="{ retry }">
        <div class="d-flex justify-content-center p-1">
          <span>通知情報取得時にエラーが発生しました。</span>
          <button @click="retry">再実行</button>
        </div>
      </template>
    </infinite-loading>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
import NotificationAreaData from "@/views/atoms/NotificationAreaData"
import InfiniteLoading from "v3-infinite-loading";

export default {
  name: "NotificationAreaBody",
  components: {
    NotificationAreaData,
    InfiniteLoading,
  },
  inject: [
    '$constant',
  ],
  props: {
    unreadChecked: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    ...mapState('mail_history_index', [
      'mailHistories',
    ]),
    noNotification() {
      if (this.unreadChecked) {
        return this.mailHistories.filter(row => row.is_read === false).length === 0;
      } else {
        return this.mailHistories.length === 0;
      }
    },
    reset() {
      if (this.mailHistories.length === 0) {
        return 0;
      } else {
        return this.mailHistories[0].id;
      }
    },
  },
  methods: {
    ...mapMutations('mail_history_index', [
      'setCurrentPageCountUp',
      'setIsRead',
    ]),
    rowRole(row) {
      return row.id !== undefined ? 'button' : '';
    },
    infiniteHandler($state) {
      sessionStorage.setItem('hideApiLoading', 'true');
      let oldHistorieslength = this.mailHistories.length;
      this.$store.dispatch('mail_history_index/loadAdditionalData').then(() => {
        if (this.mailHistories.length - oldHistorieslength < this.$constant.NOTIFICATER.PER_PAGE) {
          $state.complete();
        } else {
          this.setCurrentPageCountUp();
          $state.loaded();
        }
      }).catch(() => {
        $state.error();
      }).finally(() => {
        sessionStorage.removeItem('hideApiLoading');
      });
    },
    updateIsRead(index) {
      this.setIsRead(index);
    },
  },
}
</script>